// Auto-import SASS generated CSS
import './index.css';

export type {
  LinkProps,
  LinkBaseProps,
  LinkWithChildren,
  LinkWithText,
} from './Link';
export {default as default} from './Link';
